"use client";

import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from "react";
import { Tooltip } from "react-tooltip";
interface MyStreamActionTooltipProps {
  readonly id: string;
  readonly place?: ComponentProps<typeof Tooltip>["place"];
}
const tooltipStyle = {
  padding: "4px 8px",
  background: "#37373E",
  color: "white",
  fontSize: "13px",
  fontWeight: 500,
  borderRadius: "6px",
  boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  zIndex: 99999,
  pointerEvents: "none"
} as const;
export default function MyStreamActionTooltip(t0) {
  const $ = _c(3);
  const {
    id,
    place: t1
  } = t0;
  const place = t1 === undefined ? "top" : t1;
  let t2;
  if ($[0] !== id || $[1] !== place) {
    t2 = <Tooltip id={id} place={place} offset={8} opacity={1} positionStrategy="fixed" style={tooltipStyle} />;
    $[0] = id;
    $[1] = place;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}